export default __webpack_public_path__ + "static/images/common/logo/genius.png?65580af11deda102be7cf7b627c7f385";